<div class="slat-list">
  <icc-select-box
    [title]="slat?.name"
    [imageUrl]="slatImage"
  ></icc-select-box>

  <form [formGroup]="slatForm">
    <mat-card appearance="outlined" class="mat-elevation-2">
      <mat-form-field appearance="outline">
        <input
          type="number"
          matInput
          [placeholder]="'DOOR|Ilość lameli' | translate"
          formControlName="slatCount"
          min="1"
          [max]="slatSpace.maxSlatCount"
          >
          <mat-hint>{{ 'DOOR|Maksymalna ilość lameli:' | translate}} {{slatSpace.maxSlatCount}} </mat-hint>
          @if (slatForm.get('slatCount').hasError('max')) {
            <mat-error>
              {{ 'DOOR|Przekroczono maksymalną ilość lameli' | translate }}
            </mat-error>
          }
          @if (slatForm.get('slatCount').hasError('min')) {
            <mat-error>
              {{ 'DOOR|Minimalna ilość lameli to 1' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </mat-card>
    </form>
  </div>

  <div class="selected-summary mat-elevation-z4">
    <img [src]="slatImage" defaultImg>
    <p>{{ slat?.name }}</p>
    <button mat-raised-button (click)="close()" color="primary" [disabled]="slatForm.invalid">
      {{ 'INTERFACE|Wybierz' | translate}}
    </button>
  </div>
